import React from 'react';
import { PriceBlock } from '@hpstellar/core';
import { CarePack, CarePackCard } from '@hpstellar/core/abTest';

export default ({
    title = 'Add an HP Care Pack to protect your new laptop',
    detailsClick,
    detailsText = 'Details',
    items,
    selectedValue,
    onChange,
    disclaimer = 'Service starts on date of hardware purchase. Restrictions and limitations apply.',
}) => {
    if (!items || items.length === 0) return null;
    return (
        <CarePack
            detailsLinkProps={{
                navigate: detailsClick,
                children: detailsText,
                to: '#',
                dense: true,
            }}
            disclaimer={disclaimer}
            title={title}
        >
            {items.map((item, index) => {
                const { label, price } = item;
                const { subscriptionTerm } = price || {};

                const title = typeof label === 'string' ? label : label.description;
                const labelValue = subscriptionTerm ? `${subscriptionTerm} Subscription` : undefined;
                return (
                    <CarePackCard
                        key={index}
                        checked={item.sku === selectedValue}
                        included={item.isIncluded}
                        title={title}
                        label={labelValue}
                        list={item.keyPoints || []}
                        onChange={() => {
                            return onChange({ target: { value: item.sku } });
                        }}
                        price={
                            !item.isIncluded && (
                                <PriceBlock className="inline-price" {...item.price} style="slim" size="tiny" />
                            )
                        }
                    />
                );
            })}
        </CarePack>
    );
};
